import { render } from "./CvMatcher.vue?vue&type=template&id=78bc3fac"
import script from "./CvMatcher.vue?vue&type=script&lang=js"
export * from "./CvMatcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__